import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import type { PortsParams } from '../../models';
import { CACHE_KEYS } from '../../types';
import { logger } from '../../utils/logger';
import * as api from './api';
import { normalizePorts } from './normalize';

export const fetchPorts = createProvider(api.fetchPorts)
  .andThen((res) => normalizePorts(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Fetch ports search results list aborted');
    } else {
      logger.error('Fetch ports search results list was failed:', error);
    }
    throw error;
  });

export const portsOptions = (params: PortsParams) =>
  queryOptions({
    enabled: Boolean(params.country),
    queryFn: ({ signal }) => fetchPorts(params, { signal }),
    queryKey: CACHE_KEYS.ports(params),
  });
